import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { DialogService } from '../../dialog/dialog.service';
import { dateAsString, dayAsString } from '../../shared/date.helper';
import { Inspection } from '../../shared/interfaces';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';
import { InspectionService } from '../inspection.service';

@Component({
  selector: 'app-inspection-archived',
  templateUrl: './inspection-archived.component.html',
  styleUrls: ['./inspection-archived.component.scss'],
})
export class InspectionArchivedComponent implements OnInit {
  inspections: Inspection[] = [];

  page = 1;
  pageSize = 10;
  count = 0;
  archived = true;
  search = '';
  url = 'inspection';
  column = [
    { field: 'customerName', header: 'Customer', type: 'text', orderBy: 'customer.name' },
    { field: 'address', header: 'Location Address', type: 'text', orderBy: 'inspection.address' },
    { field: 'city', header: 'City', type: 'text', orderBy: 'inspection.city' },
    { field: 'state', header: 'State', type: 'text', orderBy: 'inspection.state' },
    { field: 'purpose', header: 'Purpose', type: 'text', orderBy: 'inspection.purpose' },
    { field: 'policyNumber', header: 'Policy No.', type: 'text', orderBy: 'policy.number' },
    { field: 'vendor.name', header: 'Vendor', type: 'text', orderBy: 'vendor.firstName' },
    { field: 'inspector.name', header: 'Inspector', type: 'text', orderBy: 'inspector.firstName' },
    { field: 'rating', header: 'Rating', type: 'text', orderBy: 'inspection.rating' },
    { field: 'completed', header: 'Completed', type: 'date', orderBy: 'inspection.completed' },
    { field: 'lastSynced', header: 'Last Synced', type: 'date', orderBy: 'inspection.lastSynced' },
  ];

  canAdd = false;
  canEdit = false;
  canReview = false;
  loadDebounced = new Subject();
  loading = true;
  actions = {
    list: [
      {
        label: 'Review',
        callback: (Inspection: Inspection) => async () => {
          console.log('Review', Inspection.id);
          return this.Review(Inspection.id);
        },
        show: item => () => {
          return this.canReview;
        },
      },
      {
        label: 'Restore',
        callback: (Inspection: Inspection) => async () => {
          return this.restore(Inspection.id);
        },
        show: item => () => {
          return this.canEdit;
        },
      },
    ],
  };

  constructor(
    public inspectionService: InspectionService,
    public userService: UserService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: DialogService,
  ) {}

  async ngOnInit() {
    // Debounce data loading
    this.loadDebounced
      .pipe(
        debounceTime(500),
        switchMap(params => this.loadDataLive(params)),
      )
      .subscribe();

    this.canAdd = await this.userService.hasPermissions([permissions.INSPECTION.CREATE]);
    this.canEdit = await this.userService.hasPermissions([permissions.INSPECTION.EDIT]);
    this.canReview = await this.userService.hasPermissions([permissions.INSPECTION.REVIEW]);
  }

  loadData(params) {
    this.loadDebounced.next(params);
  }

  async loadDataLive(params) {
    let rows: any[];

    [rows, this.count] = await this.inspectionService.archived(true, params);

    this.inspections = rows.map(i => ({
      ...i,
      day: i.dueDate ? dayAsString(new Date(i.dueDate)) : '',
    }));
    this.loading = false;
  }

  open(ev, id: number) {
    if (ev.target.tagName === 'TD') {
      this.router.navigateByUrl(`/inspection/form/${id}`);
    }
  }

  restore(id: number) {
    this.dialog.confirm().show({
      message: 'Do you really want to restore this inspection?',
      confirmed: async () => {
        await this.inspectionService.restore(id);
        this.toastr.success('Inspection Restored!');
      },
    });
  }

  Review(id: number) {
    this.router.navigateByUrl(`/inspection/review/main/${id}`);
  }
}
